// Import vue component
import loader from './loader.vue'

// Declare install function executed by app.use() in Vue 3 or Vue.use() in Vue 2
loader.install = (app) => {
  const register = app.component ? app.component.bind(app) : app.bind(app)
  register('loader', loader)
}

export default loader

// To allow use as module (npm/webpack/etc.) export component
export { loader }
